import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'

function getCorrespondingPolicy({
  plan,
  mainPeriod = undefined,
  additionalPeriods = undefined,
  policyIndex = '1'
}) {
  if (mainPeriod && plan.durations[mainPeriod]) {
    return plan.durations[mainPeriod][policyIndex] || plan.durations[mainPeriod]['1']
  } else if (additionalPeriods) {
    const planDuration = additionalPeriods
      .sort((x, y) => y - x)
      .map(p => plan.durations[p])
      .filter(Boolean)[0]
    return planDuration[policyIndex] || planDuration['1'] || planDuration
  } else {
    return getAndValidatePeriod(plan, mainPeriod)['1']
  }
}

export default getCorrespondingPolicy
